import request from '@/util/request';
import qs from 'qs';

export const getList = (params, options) =>
request.get('/api/v4ward/valueCostBudget/page', Object.assign({}, options, { params }));

export const getDetail = (params, options) =>
request.get('/api/v4ward/valueCostBudget/detail', Object.assign({}, options, { params }))

export const remove = (params, options) =>
request.post('/api/v4ward/valueCostBudget/remove', qs.stringify(params),options);

export const add = (params, options) =>
request.post('/api/v4ward/valueCostBudget/save', params,options)

export const update = (params, options) =>
request.post('/api/v4ward/valueCostBudget/update', params,options)

export const release = (params, options) =>
  request.post('/api/v4ward/valueCostBudget/release', qs.stringify(params),options);

export const getPeriodCost = (params, options) =>
  request.post('/api/v4ward/valueCostBudget/getPeriodCost', params,options);
